import * as React from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { connect } from 'react-redux';
import SafeReactPaginate from '../../General/SafeReactPaginate';
import {
    fetchPublicaciones, // NO SE ESTA UTILIZANDO fetchPublicaciones
    fetchVariaciones,
    fetchMarcas,
    fetchCategorias,
    editPublicacion,
    fetchPublicacionesEncabezado,
    resetMarcaYCategoria,
    resetPublicaciones,
    updateListPublicacionesEstado,
    setFiltroPublicacion
} from '../../../actions/publicacionesActions';
import { limpiarFiltros } from '../../../actions/generalActios';
import { fetchSellersFilter } from '../../../actions/sellersActions';
import { fetchTiposPublicacionAdm } from '../../../actions/tiposPublicacionActions';
import {
    postAprobarPublicacionApi,
    postDesaprobarPublicacionApi,
    fetchTodasPublicacionesSinImagenApi,
    processPublicacionesImageApi
} from '../../../api/axios';
import PublicacionListItem from './PublicacionListItem';
import './PublicacionStyles.css';
import PublicacionesFilter from './PublicacionesFilter';
import BigSpinner from "../../General/BigSpinner";
import { toast } from '../../../utilities/appToast';
import { filtroMedioMes } from '../../../utilities/fechasFiltro';
import { getEstadoPublicacionFromId, normalizeEstadoPublicacion } from '../../../helper/publicacionHelper';
import { setFiltroOrdenes } from '../../../actions/ordenesActions';
import { withNavigation } from '../../General/withNavigation';
import PropTypes from 'prop-types';
import { esPublicacionSinImagen } from '../../../utilities/publicacionesSinImagen';

// Wrapper para usar hooks en class component
function ListPublicacionesWrapper(props) {
    const navigate = useNavigate();
    return <ListPublicaciones {...props} navigate={navigate} />;
}

const fechaFiltro = filtroMedioMes();
const PUBLICACIONES_PRESERVE_FILTER_KEY = "publicacionesPreserveFilter";

class ListPublicaciones extends React.Component {
    constructor(props) {
        super(props);
        const storedPage = Number.parseInt(localStorage.getItem("pagina"), 10);
        const initialPage = storedPage && storedPage > 0 ? storedPage : 1;
        this.state = {
            currentPage: initialPage,
            onFilter: typeof window === 'undefined' || window.innerWidth >= 768,
            listaTipoPublicacionCargada: false,
            idPublicacionEstado: 0,
            idPublicacionEstadoAnterior: 0,
            estado: "",
            reprocesandoImagenes: false,
            progresoImagenes: ''
        }
    }

    componentDidMount() {
        const { location, publicaciones, userType, idSeller } = this.props;
        const preserveFilterOnReturn = localStorage.getItem(PUBLICACIONES_PRESERVE_FILTER_KEY) === "true";
        const filtroPersistido = this.props.filtroPublicacion || {};

        if (location?.state?.shouldFetch) {
            this.busquedaPublicaciones();
            this.props.navigate(location.pathname, { replace: true, state: {} });
            return;
        }

        if (location?.state?.onSubmitSuccess) {
            this.busquedaPublicaciones();
            this.props.navigate(location.pathname, { replace: true, state: {} });
            return;
        }

        // Siempre limpiar el filtro al montar para evitar arrastre desde otras vistas (ej: Exportables)
        const filtroInicialLimpio = {
            idSeller: (userType.isCategory || userType.isAdminMod) ? null : idSeller,
            fechaPubDesde: fechaFiltro.desde,
            fechaPubHasta: fechaFiltro.hasta,
            idTipoPubli: null,
            idTipoPublicacion: null
        };

        if (!preserveFilterOnReturn) {
            this.props.setFiltroPublicacion(filtroInicialLimpio);
        }

        if (preserveFilterOnReturn) {
            localStorage.removeItem(PUBLICACIONES_PRESERVE_FILTER_KEY);
        }

        if (publicaciones?.length > 0) {
            return;
        }

        localStorage.setItem("snerL", -1);

        if (userType.isCategory || this.props.isAdminMod) {
            this.props.fetchSellersFilter({
                Descripcion: "",
                Page: 1,
                PageSize: 100
            });
        }

        this.busquedaPublicaciones(preserveFilterOnReturn ? filtroPersistido : filtroInicialLimpio);
        this.props.editPublicacion({});
        const pag = localStorage.getItem("pagina");
        this.setState({ currentPage: pag != null ? pag : 1 });
        this.props.fetchVariaciones();
        this.cargarTipoPublicacionLista();
        this.props.fetchCategorias();
        this.props.fetchMarcas();
    }


    cargarTipoPublicacionLista = () => {
        let listaTipoPublicacion = { params: { "CantidadPagina": 100 } };
        if (!this.state.listaTipoPublicacionCargada) {
            if (this.props.userType.isCategory || this.props.userType.isAdminMod) {
                this.props.fetchTiposPublicacionAdm(listaTipoPublicacion);
            } else {
                this.props.fetchTiposPublicacionAdm(this.props.idSeller);
            }
        }
        this.setState({ listaTipoPublicacionCargada: true });
    }

    getBusquedaParams = (filtroOverride = null, pageOverride = null) => {
        const filtroPublicacion =
            (filtroOverride && typeof filtroOverride === "object" && !Array.isArray(filtroOverride))
                ? filtroOverride
                : (this.props.filtroPublicacion || {});
        const paginaActual =
            pageOverride != null && Number.isFinite(Number(pageOverride))
                ? Number(pageOverride)
                : (Number(localStorage.getItem("pagina")) || Number(this.state.currentPage) || 1);

        const idPublicacionValue = (filtroPublicacion.idPublicacion || "").toString().trim();
        const skuSellerValue = (filtroPublicacion.skuSeller || "").toString().trim();
        const skuMarketValue = (filtroPublicacion.skuMarket || "").toString().trim();

        // Detectar si hay identificadores únicos (prioridad: idPublicacion > skuSeller > skuMarket)
        const tieneIdentificadorUnico = idPublicacionValue || skuSellerValue || skuMarketValue;

        // Si hay identificador único, no enviar fechas
        const fechaPubDesdeParaEnviar = tieneIdentificadorUnico
            ? null
            : (filtroPublicacion.fechaPubDesde ?? fechaFiltro.desde);
        const fechaPubHastaParaEnviar = tieneIdentificadorUnico
            ? null
            : (filtroPublicacion.fechaPubHasta ?? fechaFiltro.hasta);

        return {
            idSeller: (this.props.userType.isCategory || this.props.userType.isAdminMod) ? filtroPublicacion.idSeller : this.props.idSeller,
            categoria: filtroPublicacion.categoria,
            marca: filtroPublicacion.marca,
            estado: filtroPublicacion.estado,
            skuSeller: filtroPublicacion.skuSeller,
            skuMarket: filtroPublicacion.skuMarket,
            fechaPubDesde: fechaPubDesdeParaEnviar,
            fechaPubHasta: fechaPubHastaParaEnviar,
            idTipoPubli: filtroPublicacion.idTipoPubli,
            sinStock: filtroPublicacion.sinStock,
            sinImagen: filtroPublicacion.sinImagen === true,
            pagina: paginaActual,
            entidadOrdenamiento: "idPublicacion",
            idPublicacion: Number.isNaN(filtroPublicacion.idPublicacion) ? null : filtroPublicacion.idPublicacion,
        };
    }

    busquedaPublicaciones = (filtroOverride = null, pageOverride = null) =>
        this.props.fetchPublicacionesEncabezado(this.getBusquedaParams(filtroOverride, pageOverride));

    reprocesarImagenes = async (publicacion = null) => {
        if (this.state.reprocesandoImagenes || !this.props.userType.isAdminMod) return;
        if (publicacion && !esPublicacionSinImagen(publicacion)) return;
        this.setState({ reprocesandoImagenes: true, progresoImagenes: 'Buscando publicaciones sin imagen...' });
        let encoladas = 0;
        let total = 0;
        try {
            const publicaciones = publicacion ? [publicacion]
                : await fetchTodasPublicacionesSinImagenApi(this.getBusquedaParams());
            const ids = [...new Set(publicaciones.map(p => Number(p.idPublicacion)))];
            total = ids.length;
            if (!total) {
                toast.info('No se encontraron publicaciones sin imagen para reprocesar.');
                return;
            }
            for (let inicio = 0; inicio < ids.length; inicio += 100) {
                this.setState({ progresoImagenes: `Encolando imágenes: ${encoladas} de ${total} publicaciones...` });
                await processPublicacionesImageApi(ids.slice(inicio, inicio + 100));
                encoladas += ids.slice(inicio, inicio + 100).length;
            }
            toast.success(`Se solicitó el reprocesamiento de ${encoladas} publicaciones. Las imágenes se actualizarán al finalizar el proceso.`);
        } catch (error) {
            toast.error(`Se encolaron ${encoladas} de ${total} publicaciones. ${error?.response?.data?.mensaje || error.message || 'No se pudo solicitar el reprocesamiento.'}`);
        } finally {
            this.setState({ reprocesandoImagenes: false, progresoImagenes: '' });
        }
    };

    onPublicacion = (idSellerBusca, idPublicacion, idSellerPublicacion, tieneRebate) => {

        localStorage.setItem("pId", idPublicacion);
        localStorage.setItem(PUBLICACIONES_PRESERVE_FILTER_KEY, "true");

        let pathReturn = `/Publicaciones`
        this.props.navigate(`/Publicaciones/Editar/${idSellerBusca}/${idPublicacion}`, {
            state: {
                pathReturn: pathReturn,
                idSellerPub: idSellerPublicacion,
                tieneRebate: tieneRebate
            }
        });
    }

    onOrdenes = (event, skuMarket) => {
        event.stopPropagation();
        this.props.setFiltroOrdenes({ skuMarket: skuMarket, fechaDesde: "2023-10-01", desdePublicacion: true });

        let pathReturn = `/Publicaciones`
        this.props.navigate(`/Ordenes/Publicacion`, {
            state: {
                pathReturn: pathReturn
            }
        });
    }


    setInitialPage = () => {
        this.setState({ currentPage: 1 });
    }

    aprobarPublicacion = (idPublicacion) => {

        const req = postAprobarPublicacionApi({ idPublicacion: idPublicacion });

        req.then(res => {
            toast.success("Publicación aprobada");
            this.props.updateListPublicacionesEstado(idPublicacion, 1);
        }).catch(err => {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo aprobarse");
        });
    }

    handlePageChange = (options) => {
        const selectedPage = options.selected + 1;
        localStorage.setItem("pagina", selectedPage);

        if (this.props.publicaciones && this.props.publicaciones.length > 0) {
            localStorage.setItem("snerL", this.props.publicaciones[0].idPublicacion);
        }

        this.setState({ currentPage: selectedPage }, () => {
            this.busquedaPublicaciones(null, selectedPage);
        });
    }


    handleEstado = (event, args) => {
        const idPublicacion = args?.idPublicacion;
        const argsEstado = normalizeEstadoPublicacion(args.estado) || getEstadoPublicacionFromId(args.estado);
        event.stopPropagation();
        switch (argsEstado) {
            case "activo": {
                const reqDesaprobar = postDesaprobarPublicacionApi({ IdPublicacion: idPublicacion });
                reqDesaprobar.then(res => {
                    toast.success("Publicación desaprobada");

                    //El método desaprobar cambia de estado 1(activo) a estado 4(en revisión)
                    this.props.updateListPublicacionesEstado(idPublicacion, 4)
                }).catch(err => {
                    (err.response.data.errores)
                        ? err.response.data.errores.forEach(error => toast.error(error))
                        : toast.error("No pudo desaprobarse");
                });
                break;
            }
            case "pausado":
                this.aprobarPublicacion(idPublicacion);
                break;
            case "pendiente_activacion":
                this.aprobarPublicacion(idPublicacion);
                break;
            case "en_revision":
                this.aprobarPublicacion(idPublicacion);
                break;
            default: break;
        }
    }

    filtrarPublicaciones = (filtros) => {
        const idPublicacionValue = (filtros?.idPublicacion || "").toString().trim();
        const skuSellerValue = (filtros?.skuSeller || "").toString().trim();
        const skuMarketValue = (filtros?.skuMarket || "").toString().trim();
        const tieneIdentificadorUnico = idPublicacionValue || skuSellerValue || skuMarketValue;

        let mergedFiltros;

        if (tieneIdentificadorUnico) {
            // Si hay identificador único, cortar arrastre de filtros previos
            mergedFiltros = {
                ...filtros,
                idPublicacion: idPublicacionValue,
                skuSeller: skuSellerValue,
                skuMarket: skuMarketValue,
                fechaPubDesde: null,
                fechaPubHasta: null
            };
        } else {
            // Sin identificador único, mantener comportamiento normal de merge
            mergedFiltros = {
                ...this.props.filtroPublicacion,
                ...filtros
            };

            if (mergedFiltros.fechaPubHasta === undefined || mergedFiltros.fechaPubHasta === null || mergedFiltros.fechaPubHasta === "") {
                mergedFiltros.fechaPubHasta = fechaFiltro.hasta;
            }
            if (mergedFiltros.fechaPubDesde === undefined || mergedFiltros.fechaPubDesde === null || mergedFiltros.fechaPubDesde === "") {
                mergedFiltros.fechaPubDesde = fechaFiltro.desde;
            }
        }

        this.props.setFiltroPublicacion(mergedFiltros);
        localStorage.setItem("pagina", 1);
        this.setState({ currentPage: 1 }, () => {
            this.busquedaPublicaciones(mergedFiltros, 1);
        });
    };


    render() {

        const { onFilter } = this.state;
        const { userType, publicaciones, loadingPublicaciones, cantidadTotal, cantidades, idSeller } = this.props;
        const getSafeResumenValue = (value) => {
            if (value == null) return 0;
            if (typeof value === "number" || typeof value === "string") return value;
            if (typeof value === "object") {
                if (typeof value.descripcion === "string") return value.descripcion;
                if (typeof value.codigo === "number" || typeof value.codigo === "string") return value.codigo;
            }
            return 0;
        };
        const pageCount = Math.max(0, Math.ceil((cantidadTotal || 0) / 10));
        const safeForcePage = Math.min(
            Math.max((Number(this.state.currentPage) || 1) - 1, 0),
            Math.max(pageCount - 1, 0)
        );
        return (
            <div className="container py-2 pub-catalog">
                <header className="pub-catalog__mast">
                    <div className="pub-catalog__intro">
                        <p className="pub-catalog__kicker">Gestión</p>
                        <h4 className="pub-catalog__title">Publicaciones</h4>
                        <p className="pub-catalog__subtitle">Estados, precios y stock del catálogo.</p>
                    </div>

                    <div className="pub-catalog__metrics-wrap">
                        <div className="publicaciones-resumen-stats list-group list-group-horizontal-md">
                            {[
                                {
                                    label: "Cantidad Total",
                                    styleClass: "publicaciones-resumen-stats__cell--total",
                                    valueClass: "publicaciones-resumen-stats__value--total",
                                    value: cantidadTotal ?? 0
                                },
                                {
                                    label: "En revisión",
                                    styleClass: "publicaciones-resumen-stats__cell--revision",
                                    valueClass: "publicaciones-resumen-stats__value--revision",
                                    value: cantidades?.enRevision ?? 0
                                },
                                {
                                    label: "Activos",
                                    styleClass: "publicaciones-resumen-stats__cell--activos",
                                    valueClass: "publicaciones-resumen-stats__value--activos",
                                    value: cantidades?.activos ?? 0
                                },
                                {
                                    label: "Con stock no publicados",
                                    styleClass: "publicaciones-resumen-stats__cell--stock",
                                    valueClass: "publicaciones-resumen-stats__value--stock",
                                    value: cantidades?.conStockNoPublicados ?? 0
                                }
                            ].map((item, i) =>
                                <div
                                    className={`list-group-item d-flex flex-column justify-content-between align-items-center border-0 py-3 publicaciones-resumen-stats__cell ${item.styleClass}`}
                                    key={i}
                                >
                                    <span className="d-block text-center mb-2 publicaciones-resumen-stats__label">{item.label}</span>
                                    <span className={`publicaciones-resumen-stats__value ${item.valueClass}`}>
                                        {getSafeResumenValue(item.value)}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>

                    {!userType.isCategory && !userType.isAdminMod &&
                        <Link to={`/Publicaciones/Nueva/${idSeller}`} className="pub-catalog__create-link">
                            <button type="button" className="pub-catalog__create">
                                <i className="fa fa-plus-circle" aria-hidden="true" /> Crear publicación
                            </button>
                        </Link>
                    }
                </header>

                <div hidden={!onFilter}>
                    <PublicacionesFilter
                        showImageFilter={true}
                        setInitialPage={this.setInitialPage}
                        allowSearchBySeller={userType.isCategory || userType.isAdminMod}
                        filtro={this.props.emptyFiltro.publicaciones === false ? this.props.filtroPublicacion : null}
                        requestParaExportar={this.filtrarPublicaciones}
                        shouldFetchOnClear={true}
                        clearFilterOnUnmount={true}
                        onMinimize={() => this.setState({ onFilter: false })}
                    />
                </div>

                {!onFilter && (
                    <button
                        type="button"
                        className="pub-catalog__filter-open"
                        onClick={() => this.setState({ onFilter: true })}
                        aria-expanded={false}
                    >
                        <span className="pub-catalog__filter-open-icon" aria-hidden="true">
                            <i className="fa fa-filter" />
                        </span>
                        <span className="pub-catalog__filter-open-copy">
                            <strong>Abrir filtros</strong>
                            <small>Identificadores, catálogo y período</small>
                        </span>
                        <i className="fa fa-chevron-down pub-catalog__filter-open-chevron" aria-hidden="true" />
                    </button>
                )}

                {userType.isAdminMod && (
                    <div className="pub-catalog__reprocess-bar">
                        <button
                            type="button"
                            className="pub-catalog__reprocess"
                            disabled={this.state.reprocesandoImagenes || loadingPublicaciones || !cantidadTotal}
                            onClick={() => this.reprocesarImagenes()}
                        >
                            <span className="pub-catalog__reprocess-icon" aria-hidden="true">
                                <i className="fa fa-refresh" />
                            </span>
                            <span className="pub-catalog__reprocess-copy">
                                <strong>Reprocesar imágenes</strong>
                                <small>Todas las publicaciones sin imagen de esta búsqueda</small>
                            </span>
                        </button>
                        <p className="pub-catalog__reprocess-note" role="status">
                            {this.state.progresoImagenes || "Incluye todas las páginas y respeta los filtros de la búsqueda."}
                        </p>
                    </div>
                )}

                {loadingPublicaciones ? <BigSpinner message="Cargando publicaciones..." /> :
                    <div className="pub-catalog__list">
                        {publicaciones?.length > 0 ?
                            publicaciones.map((publicacion, i) => {
                                return (
                                    <div
                                        role="button"
                                        tabIndex={0}
                                        key={publicacion.idPublicacion ?? i}
                                        className="p-0 m-0 text-start w-100 text-decoration-none text-body border-0 bg-transparent shadow-none publicacion-list-trigger"
                                        onClick={() => {
                                            this.onPublicacion(
                                                idSeller,
                                                publicacion.idPublicacion,
                                                publicacion.idSeller,
                                                publicacion.tieneRebate
                                            )
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.target !== e.currentTarget) return;
                                            if (e.key === "Enter" || e.key === " ") {
                                                e.preventDefault();
                                                this.onPublicacion(
                                                    idSeller,
                                                    publicacion.idPublicacion,
                                                    publicacion.idSeller,
                                                    publicacion.tieneRebate
                                                );
                                            }
                                        }}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <PublicacionListItem
                                            titulo={publicacion.titulo}
                                            skuSeller={publicacion.skuSeller}
                                            skuMarket={publicacion.skuMarket}
                                            categoria={publicacion.categoria}
                                            precioLista={publicacion.precioLista}
                                            precioPromocional={publicacion.precioPromocional}
                                            estado={publicacion.estado}
                                            img={publicacion.imagen?.urlImagen || null}
                                            idPublicacion={publicacion.idPublicacion}
                                            marca={publicacion.marca}
                                            tipoEntrega={publicacion.tipoEntrega}
                                            fechaPublicacion={publicacion.fechaPublicacion}
                                            envioGratis={publicacion.envioGratis}
                                            handleEstado={this.handleEstado}
                                            descripcionSeller={publicacion.descripcionSeller}
                                            tipoPublicacion={publicacion.tipoPublicacion}
                                            stock={publicacion.stock}
                                            isAdminOrCategory={userType.isCategory || userType.isAdminMod}
                                            productoExceptuado={publicacion.exceptuado}
                                            onOrdenes={this.onOrdenes}
                                            descripcionUmbralStock={publicacion.descripcionUmbralStock}
                                            onReprocesarImagen={esPublicacionSinImagen(publicacion) && userType.isAdminMod
                                                ? () => this.reprocesarImagenes(publicacion) : null}
                                            reprocesandoImagenes={this.state.reprocesandoImagenes}
                                        />
                                    </div>
                                )
                            })
                            :
                            <div className="pub-catalog__empty">
                                <i className="ti-package" aria-hidden="true" />
                                <p>No se encontraron resultados</p>
                            </div>
                        }
                    </div>
                }

                {pageCount > 0 && (
                    <div className="d-flex justify-content-center">
                        <SafeReactPaginate
                            previousLabel={"Anterior"}
                            nextLabel={"Siguiente"}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={pageCount}
                            marginPagesDisplayed={5}
                            pageRangeDisplayed={10}
                            onPageChange={this.handlePageChange}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"}
                            forcePage={safeForcePage}
                        />
                    </div>
                )}
            </div>
        );
    }
}
ListPublicaciones.propTypes = {
    // Hooks props
    location: PropTypes.shape({
        state: PropTypes.shape({
            shouldFetch: PropTypes.func,
            onSubmitSuccess: PropTypes.func,
        }),
        pathname: PropTypes.string,
    }),
    navigate: PropTypes.func,
    // Redux props
    idSeller: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    publicaciones: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
        idPublicacion: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })), PropTypes.shape({
        publicaciones: PropTypes.array,
    })]),
    isAdminMod: PropTypes.bool,
    userType: PropTypes.shape({
        isCategory: PropTypes.bool,
        isAdminMod: PropTypes.bool,
    }),
    filtroPublicacion: PropTypes.shape({
        fechaPubHasta: PropTypes.string,
        fechaPubDesde: PropTypes.string,
        idSeller: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        categoria: PropTypes.shape({
            codigo: PropTypes.number,
            descripcion: PropTypes.string,
        }),
        marca: PropTypes.shape({
            codigo: PropTypes.number,
            descripcion: PropTypes.string,
        }),
        estado: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        skuSeller: PropTypes.number,
        skuMarket: PropTypes.number,
        idTipoPubli: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        sinStock: PropTypes.bool,
        idPublicacion: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    loadingPublicaciones: PropTypes.bool,
    cantidadTotal: PropTypes.number,
    cantidades: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
        enRevision: PropTypes.number,
        activos: PropTypes.number,
        conStockNoPublicados: PropTypes.number,
    })]),
    emptyFiltro: PropTypes.shape({
        publicaciones: PropTypes.bool,
    }),
    // Actions props
    fetchSellersFilter: PropTypes.func,
    editPublicacion: PropTypes.func,
    fetchVariaciones: PropTypes.func,
    fetchCategorias: PropTypes.func,
    fetchMarcas: PropTypes.func,
    fetchTiposPublicacionAdm: PropTypes.func,
    fetchPublicacionesEncabezado: PropTypes.func,
    setFiltroOrdenes: PropTypes.func,
    updateListPublicacionesEstado: PropTypes.func,
    setFiltroPublicacion: PropTypes.func,
}


const mapStateToProps = state => ({
    userType: state.general.userType,
    idSeller: state.general.idSeller,
    publicaciones: state.publicaciones.publicaciones.elementos,
    loadingPublicaciones: state.publicaciones.loadingPublicaciones,
    cantidadTotal: state.publicaciones.publicaciones.cantidadTotal,
    cantidades: state.publicaciones.publicaciones.cantidades,
    filtroPublicacion: state.publicaciones.filtroPublicaciones,
    emptyFiltro: state.general.limpiar
});

export default withNavigation(connect(mapStateToProps, {
    fetchPublicaciones,
    fetchCategorias,
    fetchVariaciones,
    fetchMarcas,
    fetchSellersFilter,
    editPublicacion,
    limpiarFiltros,
    fetchTiposPublicacionAdm,
    setFiltroOrdenes,
    fetchPublicacionesEncabezado,
    resetMarcaYCategoria,
    resetPublicaciones,
    updateListPublicacionesEstado,
    setFiltroPublicacion
})(ListPublicacionesWrapper));
